import React from 'react'
import NavBar from '../components/NavBar'
import LoginForm from '../components/LoginForm'

const Login = () => {
  return (
    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
        <NavBar />
        <LoginForm />
    </div>
  )
}

export default Login